import { useSelector } from 'react-redux';

import { selectAddOns } from '@app/redux/addOns';

export const useShouldRefetchCurrentAddons = () => {
  const { addOnOrderId, submitOrder } = useSelector(selectAddOns);

  if (submitOrder.success && addOnOrderId) {
    return true;
  }
  return false;
};
